/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2025-01-10 13:11:26.

export interface MoneyTransferCancelTransactionRequest extends MoneyTransferBaseRequest<MoneyTransferCancelTransactionRequest> {
    referenceNumber: string;
    moneyTransferKey: string;
    reasonForRedelivery: string;
    comment: string;
    disallowTraffic: boolean;
    currencyCode: string;
    countryCode: string;
}

export interface MoneyTransferCancelTransactionRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferCancelTransactionRequest, C, B> {
}

export interface MoneyTransferCancelTransactionRequestBuilderImpl extends MoneyTransferCancelTransactionRequestBuilder<MoneyTransferCancelTransactionRequest, MoneyTransferCancelTransactionRequestBuilderImpl> {
}

export interface MoneyTransferCheckPayStatusRequest extends MoneyTransferBaseRequest<MoneyTransferCheckPayStatusRequest> {
    referenceNumber: string;
    currencyCode: string;
}

export interface MoneyTransferCheckPayStatusRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferCheckPayStatusRequest, C, B> {
}

export interface MoneyTransferCheckPayStatusRequestBuilderImpl extends MoneyTransferCheckPayStatusRequestBuilder<MoneyTransferCheckPayStatusRequest, MoneyTransferCheckPayStatusRequestBuilderImpl> {
}

export interface MoneyTransferGetAdditionalServicesRequest extends MoneyTransferBaseRequest<MoneyTransferGetAdditionalServicesRequest> {
    code: string;
    destinationCountryCode: string;
    destinationCurrencyCode: string;
    subServices: MoneyTransferGetAdditionalSubServiceReqDto[];
}

export interface MoneyTransferGetAdditionalServicesRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetAdditionalServicesRequest, C, B> {
}

export interface MoneyTransferGetAdditionalServicesRequestBuilderImpl extends MoneyTransferGetAdditionalServicesRequestBuilder<MoneyTransferGetAdditionalServicesRequest, MoneyTransferGetAdditionalServicesRequestBuilderImpl> {
}

export interface MoneyTransferGetCitiesRequest extends MoneyTransferBaseRequest<MoneyTransferGetCitiesRequest> {
    stateCode: string;
    countryCode: string;
}

export interface MoneyTransferGetCitiesRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetCitiesRequest, C, B> {
}

export interface MoneyTransferGetCitiesRequestBuilderImpl extends MoneyTransferGetCitiesRequestBuilder<MoneyTransferGetCitiesRequest, MoneyTransferGetCitiesRequestBuilderImpl> {
}

export interface MoneyTransferGetCountriesRequest extends MoneyTransferBaseRequest<MoneyTransferGetCountriesRequest> {
}

export interface MoneyTransferGetCountriesRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetCountriesRequest, C, B> {
}

export interface MoneyTransferGetCountriesRequestBuilderImpl extends MoneyTransferGetCountriesRequestBuilder<MoneyTransferGetCountriesRequest, MoneyTransferGetCountriesRequestBuilderImpl> {
}

export interface MoneyTransferGetDeliveryServicesRequest extends MoneyTransferBaseRequest<MoneyTransferGetDeliveryServicesRequest> {
    destinationCountryCode: string;
    destinationCurrencyCode: string;
}

export interface MoneyTransferGetDeliveryServicesRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetDeliveryServicesRequest, C, B> {
}

export interface MoneyTransferGetDeliveryServicesRequestBuilderImpl extends MoneyTransferGetDeliveryServicesRequestBuilder<MoneyTransferGetDeliveryServicesRequest, MoneyTransferGetDeliveryServicesRequestBuilderImpl> {
}

export interface MoneyTransferGetDestinationCountriesRequest extends MoneyTransferBaseRequest<MoneyTransferGetDestinationCountriesRequest> {
}

export interface MoneyTransferGetDestinationCountriesRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetDestinationCountriesRequest, C, B> {
}

export interface MoneyTransferGetDestinationCountriesRequestBuilderImpl extends MoneyTransferGetDestinationCountriesRequestBuilder<MoneyTransferGetDestinationCountriesRequest, MoneyTransferGetDestinationCountriesRequestBuilderImpl> {
}

export interface MoneyTransferGetIdDocumentsRequest extends MoneyTransferBaseRequest<MoneyTransferGetIdDocumentsRequest> {
    countryCode: string;
}

export interface MoneyTransferGetIdDocumentsRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetIdDocumentsRequest, C, B> {
}

export interface MoneyTransferGetIdDocumentsRequestBuilderImpl extends MoneyTransferGetIdDocumentsRequestBuilder<MoneyTransferGetIdDocumentsRequest, MoneyTransferGetIdDocumentsRequestBuilderImpl> {
}

export interface MoneyTransferGetStatesRequest extends MoneyTransferBaseRequest<MoneyTransferGetStatesRequest> {
    countryCode: string;
}

export interface MoneyTransferGetStatesRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferGetStatesRequest, C, B> {
}

export interface MoneyTransferGetStatesRequestBuilderImpl extends MoneyTransferGetStatesRequestBuilder<MoneyTransferGetStatesRequest, MoneyTransferGetStatesRequestBuilderImpl> {
}

export interface MoneyTransferPayOutTransactionRequest extends MoneyTransferBaseRequest<MoneyTransferPayOutTransactionRequest> {
    receiver: MoneyTransferClientDataCommon;
    sender: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    additionalServices: MoneyTransferTransactionAdditionalServicesCommonDto;
    exchangeRate: number;
    expectedPayout: number;
    principal: number;
    referenceNumber: string;
    newReferenceNumber: string;
    moneyTransferKey: string;
    transactionSplitPayout: MoneyTransferPayOutTransactionSplitPayoutDto;
}

export interface MoneyTransferPayOutTransactionRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferPayOutTransactionRequest, C, B> {
}

export interface MoneyTransferPayOutTransactionRequestBuilderImpl extends MoneyTransferPayOutTransactionRequestBuilder<MoneyTransferPayOutTransactionRequest, MoneyTransferPayOutTransactionRequestBuilderImpl> {
}

export interface MoneyTransferPriceTransactionRequest extends MoneyTransferBaseRequest<MoneyTransferPriceTransactionRequest> {
    principal: number;
    fixed: boolean;
    expectedPayOut: number;
    currencyCode: string;
    destinationCountryCode: string;
    destinationStateCode: string;
    destinationCity: string;
    destinationCurrencyCode: string;
}

export interface MoneyTransferPriceTransactionRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferPriceTransactionRequest, C, B> {
}

export interface MoneyTransferPriceTransactionRequestBuilderImpl extends MoneyTransferPriceTransactionRequestBuilder<MoneyTransferPriceTransactionRequest, MoneyTransferPriceTransactionRequestBuilderImpl> {
}

export interface MoneyTransferSearchForTransactionRequest extends MoneyTransferBaseRequest<MoneyTransferSearchForTransactionRequest> {
    referenceNumber: string;
    currencyCodes: string[];
    searchFlag: string;
}

export interface MoneyTransferSearchForTransactionRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferSearchForTransactionRequest, C, B> {
}

export interface MoneyTransferSearchForTransactionRequestBuilderImpl extends MoneyTransferSearchForTransactionRequestBuilder<MoneyTransferSearchForTransactionRequest, MoneyTransferSearchForTransactionRequestBuilderImpl> {
}

export interface MoneyTransferSearchRequest extends MoneyTransferBaseRequest<MoneyTransferSearchRequest> {
    searchRequest: SearchRequest;
}

export interface MoneyTransferSearchRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferSearchRequest, C, B> {
}

export interface MoneyTransferSearchRequestBuilderImpl extends MoneyTransferSearchRequestBuilder<MoneyTransferSearchRequest, MoneyTransferSearchRequestBuilderImpl> {
}

export interface MoneyTransferSendTransactionRequest extends MoneyTransferBaseRequest<MoneyTransferSendTransactionRequest> {
    transactionId: string;
    cardNumber: string;
    cardProvider: string;
    cardPaymentId: string;
}

export interface MoneyTransferSendTransactionRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferSendTransactionRequest, C, B> {
}

export interface MoneyTransferSendTransactionRequestBuilderImpl extends MoneyTransferSendTransactionRequestBuilder<MoneyTransferSendTransactionRequest, MoneyTransferSendTransactionRequestBuilderImpl> {
}

export interface MoneyTransferValidateSendTransactionRequest extends MoneyTransferBaseRequest<MoneyTransferValidateSendTransactionRequest> {
    sender: MoneyTransferClientDataCommon;
    receiver: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    additionalServices: MoneyTransferAdditionalServicesReqDto;
    requestId: string;
}

export interface MoneyTransferValidateSendTransactionRequestBuilder<C, B> extends MoneyTransferBaseRequestBuilder<MoneyTransferValidateSendTransactionRequest, C, B> {
}

export interface MoneyTransferValidateSendTransactionRequestBuilderImpl extends MoneyTransferValidateSendTransactionRequestBuilder<MoneyTransferValidateSendTransactionRequest, MoneyTransferValidateSendTransactionRequestBuilderImpl> {
}

export interface MoneyTransferBaseRequest<T> extends Serializable {
    serviceCode: string;
    digital: boolean;
}

export interface MoneyTransferBaseRequestBuilder<T, C, B> {
}

export interface MoneyTransferCancelTransactionDtoMapper {
}

export interface MoneyTransferCheckPayStatusDtoMapper {
}

export interface MoneyTransferCityResultDtoMapper {
}

export interface MoneyTransferGetAdditionalServicesReqDtoMapper {
}

export interface MoneyTransferGetByReferenceNumberDtoMapper {
}

export interface MoneyTransferGetDeliveryServicesDtoMapper {
}

export interface MoneyTransferGetIdDocumentsDtoMapper {
}

export interface MoneyTransferGetStatesDtoMapper {
}

export interface MoneyTransferIdDtoMapper {
}

export interface MoneyTransferPayOutTransactionDtoMapper {
}

export interface MoneyTransferPriceTransactionDtoMapper {
}

export interface MoneyTransferReqDtoMapper {
}

export interface MoneyTransferSearchForTransactionDtoMapper {
}

export interface MoneyTransferSearchRequestDtoMapper {
}

export interface MoneyTransferSendTransactionDtoMapper {
}

export interface MoneyTransferValidateSendTransactionDtoMapper {
}

export interface GetAdditionalServicesReqDto extends ChannelConfigurationBaseDto<GetAdditionalServicesReqDto> {
    code: string;
    subServices: GetAdditionalSubServiceReqDto[];
    serviceProviderCode: string;
}

export interface GetAdditionalServicesFieldRecordReqDto {
    recordId: string;
    serviceProviderCode: string;
}

export interface SaveAdditionalServicesReqDto {
    code: string;
    subService: SaveAdditionalSubServiceReqDto;
    serviceProviderCode: string;
}

export interface CreateChangeRequestDto {
    transactionId: string;
    receiverFirstName: string;
    receiverLastName: string;
    senderFirstName: string;
    senderLastName: string;
    destinationCountryCode: string;
    cancelRefundReason: string;
    changeRequestType: ChangeRequestType;
    serviceType: string;
}

export interface CreateConnectionConfigurationDto {
    serviceCode: string;
    addressName: string;
    addressPort: number;
    defaultTerminalId: string;
    subServiceCodeSend: string;
    subServiceCodeReceive: string;
    subServiceCodeSendDigital: string;
    subServiceCodeReceiveDigital: string;
    supportedCurrencies: string[];
    defaultCurrency: string;
}

export interface CreateFormConfigurationBaseDto {
    configurationType: ConfigurationType;
    configuration: string;
    activated: boolean;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface UpdateDefaultFormConfigurationByTypeDto {
    configurationType: ConfigurationType;
    configuration: string;
    activated: boolean;
}

export interface UpdateFormConfigurationDto {
    id: string;
    configuration: string;
    activated: boolean;
}

export interface MoneyTransferCheckPayStatusDto extends MoneyTransferObjectBase {
    referenceNumber: string;
    currencyCode: string;
}

export interface MoneyTransferGetAdditionalServicesReqDto extends MoneyTransferObjectBase {
    code: string;
    destinationCountryCode: string;
    destinationCurrencyCode: string;
    subServices: MoneyTransferGetAdditionalSubServiceReqDto[];
}

export interface MoneyTransferGetCitiesDto extends MoneyTransferObjectBase {
    stateCode: string;
    countryCode: string;
}

export interface MoneyTransferGetCountriesDto {
    serviceCode: string;
}

export interface MoneyTransferGetDestinationCountriesDto {
    serviceCode: string;
}

export interface MoneyTransferGetIdDocumentsDto extends MoneyTransferObjectBase {
    countryCode: string;
}

export interface MoneyTransferGetStatesDto extends MoneyTransferObjectBase {
    countryCode: string;
}

export interface MoneyTransferPayOutTransactionDto extends MoneyTransferObjectBase {
    receiver: MoneyTransferClientDataCommon;
    sender: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    additionalServices: MoneyTransferTransactionAdditionalServicesCommonDto;
    exchangeRate: number;
    expectedPayout: number;
    principal: number;
    referenceNumber: string;
    newReferenceNumber: string;
    moneyTransferKey: string;
    transactionSplitPayoutDto: MoneyTransferPayOutTransactionSplitPayoutDto;
}

export interface MoneyTransferPriceTransactionDto extends MoneyTransferObjectBase {
    principal: number;
    fixed: boolean;
    expectedPayOut: number;
    currencyCode: string;
    destinationCountryCode: string;
    destinationStateCode: string;
    destinationCity: string;
    destinationCurrencyCode: string;
    additionalServices: MoneyTransferAdditionalServicesReqDto;
}

export interface MoneyTransferSearchForTransactionDto extends MoneyTransferObjectBase {
    referenceNumber: string;
    currencyCodes: string[];
    searchFlag: string;
}

export interface MoneyTransferSendTransactionDto extends MoneyTransferObjectBase {
    transactionId: string;
    cardNumber: string;
    cardProvider: string;
    cardPaymentId: string;
}

export interface MoneyTransferValidateSendTransactionDto extends MoneyTransferObjectBase {
    sender: MoneyTransferClientDataCommon;
    receiver: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    additionalServices: MoneyTransferAdditionalServicesReqDto;
    requestId: string;
}

export interface MoneyTransferGetDeliveryServicesDto extends MoneyTransferObjectBase {
    destinationCountryCode: string;
    destinationCurrencyCode: string;
}

export interface SearchRequest extends Serializable {
    filters: FilterRequest[];
    sorts: SortRequest[];
    page: number;
    size: number;
}

export interface MoneyTransferDigitalSendTransactionDto {
    transactionId: string;
    cardNumber: string;
    cardProvider: string;
    cardPaymentId: string;
}

export interface MoneyTransferDigitalValidateTransactionDto {
    receiver: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    serviceCode: string;
    requestId: string;
    additionalServices: MoneyTransferAdditionalServicesReqDto;
}

export interface MoneyTransferGetAdditionalSubServiceReqDto {
    subCode: string;
}

export interface MoneyTransferClientDataCommon {
    firstName: string;
    middleName: string;
    lastName: string;
    maternalName: string;
    parentName: string;
    dateOfBirth: DateAsString;
    place: string;
    placeOfBirth: string;
    stateOfBirth: string;
    countryOfResidence: string;
    countryOfBirth: string;
    idPermanent: boolean;
    idExpiryDate: DateAsString;
    hasIdDateOfIssue: boolean;
    idDateOfIssue: DateAsString;
    idIssuer: string;
    idNumber: string;
    countryOfIdIssue: string;
    idType: string;
    citizenship: string;
    personalId: string;
    phoneNumber: string;
    email: string;
    state: string;
    streetName: string;
    residenceNumber: string;
    zip: string;
    mobilePhoneNumber: MoneyTransferMobilePhoneNumberCommon;
    initialClientData: MoneyTransferInitialClientDataCommon;
    occupation: string;
    additionalNote: string;
}

export interface MoneyTransferRemoteClientDataCommon {
    firstName: string;
    middleName: string;
    lastName: string;
    maternalName: string;
    place: string;
    countryOfResidence: string;
}

export interface MoneyTransferTransactionDataCommon {
    fixed: boolean;
    originatingAmount: number;
    originatingCountryCode: string;
    originatingCurrencyCode: string;
    destinationAmount: number;
    destinationCountryCode: string;
    destinationStateCode: string;
    destinationCity: string;
    destinationCurrencyCode: string;
    testQuestion: string;
    testAnswer: string;
    purposeOfTransaction: string;
}

export interface MoneyTransferTransactionAdditionalServicesCommonDto {
    code: string;
    subServices: MoneyTransferTransactionAdditionalSubServiceCommonDto[];
    totalCharges: number;
}

export interface MoneyTransferPayOutTransactionSplitPayoutDto {
    hasAmount1: boolean;
    amount1CurrencyCode: string;
    amount1: number;
    hasAmount2: boolean;
    amount2CurrencyCode: string;
    amount2: number;
}

export interface MoneyTransferAdditionalServicesReqDto {
    code: string;
    subServices: MoneyTransferAdditionalSubServiceDto[];
}

export interface Serializable {
}

export interface GetAdditionalSubServiceReqDto {
    subCode: string;
}

export type Mono<T> = T & {
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface AdditionalServicesResultDto {
    id: string;
    code: string;
    externalId: string;
    serviceProviderCode: string;
    subServices: AdditionalSubServiceResultDto[];
    problems: ProblemBase[];
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface AdditionalServicesCheckBoxDto {
    id: string;
    hostFieldTag: string;
    fieldLabel: string;
    problems: ProblemBase[];
    hasAnyErrors: boolean;
    tindex: string;
}

export interface AdditionalServicesComboListDto {
    id: string;
    fieldLabel: string;
    hostFieldTag: string;
    requiredString: string;
    dataLength: string;
    newLine: string;
    items: AdditionalServicesComboListItemDto[];
    problems: ProblemBase[];
    hasAnyErrors: boolean;
    tindex: string;
}

export interface InternalAdditionalServicesResultDto {
    id: string;
    code: string;
    externalId: string;
    serviceProviderCode: string;
    subServices: InternalAdditionalSubServiceResultDto[];
    problems: ProblemBase[];
}

export interface AdditionalServicesOutputFieldDto {
    id: string;
    fieldLabel: string;
    hostFieldTag: string;
    dataType: string;
    description: string;
    problems: ProblemBase[];
    hasAnyErrors: boolean;
}

export interface AdditionalServicesRadioButtonGroupDto {
    id: string;
    fieldLabel: string;
    hostFieldTag: string;
    uiSize: string;
    requiredString: string;
    radioButtons: AdditionalServicesRadioButtonDto[];
    problems: ProblemBase[];
    hasAnyErrors: boolean;
    tindex: string;
}

export interface AdditionalServicesTxnEntryDto {
    id: string;
    fieldLabel: string;
    hostFieldTag: string;
    dataType: string;
    requiredString: string;
    dataLength: string;
    uiSize: string;
    newLine: string;
    mask: string;
    problems: ProblemBase[];
    hasAnyErrors: boolean;
    tindex: string;
}

export interface SaveAdditionalSubServiceReqDto {
    subCode: string;
    externalCode: string;
    description: string;
    templates: SaveAdditionalSubServiceTemplateReqDto[];
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface ChangeRequestCommon {
    id: string;
    terminalId: string;
    locationId: string;
    agentId: string;
    operatorId: string;
    transactionInternalReferenceNumber: string;
    transactionExternalReferenceNumber: string;
    receiverFirstName: string;
    receiverLastName: string;
    senderFirstName: string;
    senderLastName: string;
    destinationCountryCode: string;
    cancelRefundReason: string;
    changeRequestType: ChangeRequestType;
    transactionType: TransactionType;
    changeRequestStateType: ChangeRequestStateType;
    created: DateAsString;
    updated: DateAsString;
}

export interface ConnectionConfigurationCommon {
    id: string;
    serviceCode: string;
    addressName: string;
    addressPort: number;
}

export interface CreateWUMoneyReceivingUserSearchFormConfigurationDto extends CreateFormConfigurationBaseDto {
    countryId: string;
}

export interface CreateWUMoneyReceivingUserSenderFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface CreateWUMoneyReceivingUserRemoteReceiverFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface CreateWUMoneyReceivingTransactionSearchFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface CreateWUMoneyReceivingTransactionFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface CreateWUMoneyReceivingConfirmDataFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface SetWUMoneySendingTransactionFormConfigurationDto extends CreateFormConfigurationBaseDto {
    amountFrom: number;
    amountTo: number;
}

export interface SetWUMoneySendingReceiverFormConfigurationDto extends CreateFormConfigurationBaseDto {
    destinationCountryId: string;
}

export interface SetWUMoneySendingSenderFormConfigurationDto extends CreateFormConfigurationBaseDto {
    amountFrom: number;
    amountTo: number;
}

export interface SetWUMoneySendingCalculatorFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface SetWUMoneySendingCalculationFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface SetWUMoneySendingFinalCalculationFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface SetWUMoneySendingMainInfoFormConfigurationDto extends CreateFormConfigurationBaseDto {
}

export interface FormConfigurationBaseResponseDto {
    id: string;
    configurationType: ConfigurationType;
    createdBy: string;
    createdAt: DateAsString;
    updatedBy: string;
    updatedAt: DateAsString;
    configuration: string;
    default: boolean;
    activated: boolean;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface WUMoneySendingSenderFormConfigurationResponseDto extends FormConfigurationBaseResponseDto {
    amountFrom: number;
    amountTo: number;
}

export interface Country {
    id: string;
    name: string;
}

export interface MoneyTransferCanceledTransactionResultDto {
    referenceNumber: string;
    canceled: boolean;
}

export interface RequestHeaderBaseInfo {
    userType: RequestUserType;
    applicationAccessId: string;
    sessionRoleType: SessionRoleType;
    appInfo: RequestApplicationInfo;
    tenantInfo: RequestTenantInfo;
    userInfo: RequestUserInfo;
    operationInfo: RequestOperationInfo;
    terminalInfo: RequestTerminalInfo;
}

export interface MoneyTransferObjectBase extends RequestHeaderInfoDtoBase {
    serviceCode: string;
    subServiceCode: string;
    digital: boolean;
}

export interface MoneyTransferTransactionPayStatusCheckResultDto {
    transactions: MoneyTransferPayStatusTransactionCommon[];
}

export interface MoneyTransferGetAdditionalServicesResultDto {
    id: string;
    code: string;
    subServices: MoneyTransferGetAdditionalSubServiceResultDto[];
    problems: ProblemBase[];
}

export interface MoneyTransferPayOutMoneyRequestResultDto {
    id: string;
    internalReferenceNumber: string;
    receiver: MoneyTransferClientDataCommon;
    sender: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    common: MoneyTransferCommonDataCommon;
    additionalService: MoneyTransferTransactionAdditionalServicesCommonDto;
    exchangeRate: number;
    expectedPayout: number;
    principal: number;
    referenceNumber: string;
    newReferenceNumber: string;
    payOutMoneyRequestStateType: string;
}

export interface MoneyTransferSendMoneyRequestResultDto {
    id: string;
    internalReferenceNumber: string;
    sender: MoneyTransferClientDataCommon;
    receiver: MoneyTransferRemoteClientDataCommon;
    transaction: MoneyTransferTransactionDataCommon;
    common: MoneyTransferCommonDataCommon;
    financials: MoneyTransferFinancialDataCommon;
    additionalServices: MoneyTransferTransactionAdditionalServicesCommonDto;
    externalReferenceNumber: string;
    sendMoneyRequestStateType: string;
    date: DateAsString;
    cardNumber: string;
    cardProvider: string;
}

export interface MoneyTransferCityResultDto {
    name: string;
}

export interface MoneyTransferCountryResultDto {
    name: string;
    code: string;
}

export interface MoneyTransferDestinationCountryResultDto {
    name: string;
    code: string;
    hasStates: boolean;
    currencies: MoneyTransferDestinationCurrencyResultDto[];
}

export interface MoneyTransferIdDocumentResultDto {
    name: string;
    code: string;
}

export interface MoneyTransferStateResultDto {
    code: string;
    name: string;
    hasCities: boolean;
}

export interface MoneyTransferTransactionPayOutResultDto {
    referenceNumber: string;
    paidDate: string;
    executedDateTime: DateAsString;
}

export interface MoneyTransferTransactionPricingResultDto {
    charges: number;
    exchangeRate: number;
    expectedPayout: number;
    gross: number;
    principal: number;
    discountAmount: number;
    currencyCode: string;
    destinationCountryCode: string;
    destinationStateCode: string;
    destinationCity: string;
    destinationCurrencyCode: string;
    requestId: string;
    additionalServicesFinancial: MoneyTransferPriceAdditionalServicesFinancialResultDto;
}

export interface MoneyTransferTransactionSearchResultDto {
    moneyTransferTransactions: MoneyTransferTransactionCommon[];
}

export interface InternalTransactionDto {
}

export interface MoneyTransferTransactionSendingResultDto {
    referenceNumber: string;
    executedDateTime: DateAsString;
}

export interface SuspendRequestNotificationDto {
    id: string;
    transactionId: string;
    message: string;
    details: string;
    success: boolean;
    read: boolean;
    suspendStatus: SuspendStatus;
}

export interface WebPageResponseEntity<T> extends WebResponseEntity<GetPagingResponseDto<T>> {
    body: WebResponseObject<GetPagingResponseDto<T>>;
}

export interface MoneyTransferDeliveryServiceDataCommon {
    code: string;
    name: string;
    route: string;
}

export interface FilterRequest extends Serializable {
    key: string;
    operator: Operator;
    field_type: FieldType;
    value: any;
    value_to: any;
    values: any[];
}

export interface SortRequest extends Serializable {
    key: string;
    direction: SortDirection;
}

/**
 * @deprecated for removal
 */
export interface MoneyTransferTransactionDigitalSendingResultDto {
    referenceNumber: string;
}

export interface MoneyTransferMobilePhoneNumberCommon {
    callCode: string;
    mobileNumber: string;
}

export interface MoneyTransferInitialClientDataCommon {
    fields: MoneyTransferClientFieldDataCommon[];
}

export interface MoneyTransferTransactionAdditionalSubServiceCommonDto {
    subCode: string;
    templateId: string;
    hostData: MoneyTransferAdditionalServicesHostDataCommon[];
    financial: MoneyTransferAdditionalServiceFinancialCommon;
}

export interface MoneyTransferAdditionalSubServiceDto {
    subCode: string;
    templateId: string;
    hostData: MoneyTransferAdditionalServiceHostDataDto[];
}

export interface ChannelConfigurationBaseDto<T> extends Serializable {
    addressName: string;
    addressPort: number;
}

export interface AdditionalSubServiceResultDto {
    id: string;
    subCode: string;
    description: string;
    externalId: string;
    templates: AdditionalServicesTemplateDto[];
    delivery: boolean;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface AdditionalServicesComboListItemDto {
    value: string;
    fieldLabel: string;
    tindex: string;
}

export interface InternalAdditionalSubServiceResultDto {
    id: string;
    subCode: string;
    description: string;
    externalId: string;
}

export interface AdditionalServicesRadioButtonDto {
    id: string;
    filedLabel: string;
    hostValue: string;
    uiSize: string;
    tindex: string;
}

export interface SaveAdditionalSubServiceTemplateReqDto {
    category: string;
    header: SaveAdditionalSubServiceHeaderReqDto;
    textFields: SaveAdditionalSubServiceTextFieldReqDto[];
    fieldRecordSet: SaveAdditionalSubServiceFieldRecordSetReqDto;
    outputFieldRecordSet: SaveAdditionalSubServiceOutputFieldRecordSetReqDto;
    tindex: string;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface RequestApplicationInfo extends RequestInfoBase {
    applicationId: string;
    language: string;
}

export interface RequestTenantInfo extends RequestInfoBase {
    tenantAccessId: string;
    country: string;
}

export interface RequestUserInfo extends RequestInfoBase {
    userId: string;
    serviceId: string;
    requestPermission: number;
    subservicePermission: number;
}

export interface RequestOperationInfo extends RequestInfoBase {
    operationId: string;
    unitGroupId: string;
    unitId: string;
}

export interface RequestTerminalInfo extends RequestInfoBase {
    terminalId: string;
    locationId: string;
}

export interface RequestHeaderInfoDtoBase {
    requestHeaderInfo: RequestHeaderBaseInfo;
}

export interface MoneyTransferPayStatusTransactionCommon {
    referenceNumber: string;
    fillingDateTime: string;
    moneyTransferKey: string;
    status: string;
    messageForStatus: string;
    principal: number;
    originatingCountryCode: string;
    originatingCurrencyCode: string;
    receiverFirstName: string;
    receiverLastName: string;
    senderFirstName: string;
    senderLastName: string;
    additionalServices: MoneyTransferTransactionAdditionalServicesCommonDto;
}

export interface MoneyTransferGetAdditionalSubServiceResultDto {
    id: string;
    code: string;
    templates: MoneyTransferGetAdditionalServicesTemplateResultDto[];
    delivery: boolean;
}

export interface MoneyTransferCommonDataCommon {
    countryCode: string;
    userId: string;
    terminalId: string;
    locationId: string;
    agentId: string;
}

export interface MoneyTransferFinancialDataCommon {
    charges: number;
    exchangeRate: number;
    expectedPayout: number;
    gross: number;
    principal: number;
    discountAmount: number;
}

export interface MoneyTransferDestinationCurrencyResultDto {
    name: string;
    code: string;
}

export interface MoneyTransferPriceAdditionalServicesFinancialResultDto {
    code: string;
    totalCharges: number;
    subServicesFinancials: MoneyTransferPriceAdditionalSubServiceFinancialResultDto[];
}

export interface MoneyTransferTransactionCommon {
    referenceNumber: string;
    newReferenceNumber: string;
    fillingDateTime: string;
    principal: number;
    charges: number;
    moneyTransferKey: string;
    exchangeRate: number;
    status: string;
    messageForStatus: string;
    expectedPayout: number;
    hasAmount1: boolean;
    amount1CurrencyCode: string;
    amount1: number;
    hasAmount2: boolean;
    amount2CurrencyCode: string;
    amount2: number;
    destinationCountryCode: string;
    destinationCurrencyCode: string;
    originalDestinationCountryCode: string;
    originalDestinationCurrencyCode: string;
    originatingCountryCode: string;
    originatingCurrencyCode: string;
    receiverFirstName: string;
    receiverLastName: string;
    senderFirstName: string;
    senderLastName: string;
    senderCity: string;
    senderState: string;
    senderZip: string;
    senderPhone: string;
    senderCountryCode: string;
    senderStreet: string;
    additionalServices: MoneyTransferTransactionAdditionalServicesCommonDto;
}

export interface GetPagingResponseDto<T> {
    list: T[];
    totalCount: number;
}

export interface MoneyTransferClientFieldDataCommon {
    fieldName: string;
    value: string;
}

export interface MoneyTransferAdditionalServicesHostDataCommon {
    id: string;
    hostValue: string;
    hostDataType: string;
}

export interface MoneyTransferAdditionalServiceFinancialCommon {
    outputHostFieldId: string;
    charges: number;
}

export interface MoneyTransferAdditionalServiceHostDataDto {
    id: string;
    hostValue: string;
    hostDataType: string;
}

export interface CorePublisher<T> extends Publisher<T> {
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface AdditionalServicesTemplateDto {
    id: string;
    category: string;
    header: AdditionalServicesTemplateHeaderDto;
    textFields: AdditionalServicesTemplateTextFieldDto[];
    fieldRecordSet: AdditionalServicesFieldRecordSetDto;
    outputFieldRecordSet: AdditionalServicesOutputFieldRecordSetDto;
    tindex: string;
}

export interface SaveAdditionalSubServiceHeaderReqDto {
    templateDescription: string;
    numLines: string;
    tindex: string;
}

export interface SaveAdditionalSubServiceTextFieldReqDto {
    textToDisplay: string;
    tindex: string;
}

export interface SaveAdditionalSubServiceFieldRecordSetReqDto {
    textEntries: SaveAdditionalSubServiceTextEntryReqDto[];
    comboList: SaveAdditionalSubServiceComboListReqDto[];
    checkBoxes: SaveAdditionalSubServiceCheckBoxReqDto[];
    radioButtonGroupList: SaveAdditionalSubServiceRadioButtonGroupReqDto[];
}

export interface SaveAdditionalSubServiceOutputFieldRecordSetReqDto {
    outputFields: CreateAdditionalSubServiceOutputFieldReqDto[];
}

export interface RequestInfoBase {
}

export interface MoneyTransferGetAdditionalServicesTemplateResultDto {
    id: string;
    category: string;
    header: MoneyTransferAdditionalServicesTemplateHeaderResultDto;
    textFields: MoneyTransferAdditionalServicesTextFieldResultDto[];
    fieldRecordSet: MoneyTransferAdditionalServicesFieldRecordSetDto;
    outputFieldRecordSet: MoneyTransferGetAdditionalServicesOutputFieldRecordSetDto;
    tindex: string;
}

export interface MoneyTransferPriceAdditionalSubServiceFinancialResultDto {
    subCode: string;
    charges: number;
}

export interface AdditionalServicesTemplateHeaderDto {
    id: string;
    templateDescription: string;
    numLines: string;
    tindex: string;
}

export interface AdditionalServicesTemplateTextFieldDto {
    id: string;
    textToDisplay: string;
    tindex: string;
}

export interface AdditionalServicesFieldRecordSetDto {
    id: string;
    textEntries: AdditionalServicesTxnEntryDto[];
    comboLists: AdditionalServicesComboListDto[];
    radioButtonGroupList: AdditionalServicesRadioButtonGroupDto[];
    checkBoxes: AdditionalServicesCheckBoxDto[];
}

export interface AdditionalServicesOutputFieldRecordSetDto {
    id: string;
    outputFields: AdditionalServicesOutputFieldDto[];
}

export interface SaveAdditionalSubServiceTextEntryReqDto {
    fieldLabel: string;
    hostFieldTag: string;
    dataType: string;
    requiredString: string;
    dataLength: string;
    uiSize: string;
    newLine: string;
    mask: string;
    tindex: string;
}

export interface SaveAdditionalSubServiceComboListReqDto {
    fieldLabel: string;
    hostFieldTag: string;
    requiredString: string;
    dataLength: string;
    newLine: string;
    items: SaveAdditionalSubServiceComboListItemReqDto[];
    tindex: string;
}

export interface SaveAdditionalSubServiceCheckBoxReqDto {
    fieldLabel: string;
    hostFieldTag: string;
    requiredString: string;
    tindex: string;
}

export interface SaveAdditionalSubServiceRadioButtonGroupReqDto {
    fieldLabel: string;
    hostFieldTag: string;
    uiSize: string;
    requiredString: string;
    radioButtons: CreateAdditionalSubServiceRadioButtonReqDto[];
    tindex: string;
}

export interface CreateAdditionalSubServiceOutputFieldReqDto {
    hostFieldTag: string;
    fieldLabel: string;
    dataType: string;
    description: string;
}

export interface MoneyTransferAdditionalServicesTemplateHeaderResultDto {
    id: string;
    templateDescription: string;
    numLines: string;
    tindex: string;
}

export interface MoneyTransferAdditionalServicesTextFieldResultDto {
    id: string;
    textToDisplay: string;
    tindex: string;
}

export interface MoneyTransferAdditionalServicesFieldRecordSetDto {
    id: string;
    textEntries: MoneyTransferAdditionalServicesTxnEntryResultDto[];
    comboLists: MoneyTransferAdditionalServicesComboListResultDto[];
    radioButtonGroupList: MoneyTransferAdditionalServicesRadioButtonGroupResultDto[];
    checkBoxes: MoneyTransferAdditionalServicesCheckBoxResultDto[];
}

export interface MoneyTransferGetAdditionalServicesOutputFieldRecordSetDto {
    outputFields: MoneyTransferAdditionalSubServiceOutputFieldResultDto[];
}

export interface Publisher<T> {
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface SaveAdditionalSubServiceComboListItemReqDto {
    value: string;
    fieldLabel: string;
    tindex: string;
}

export interface CreateAdditionalSubServiceRadioButtonReqDto {
    fieldLabel: string;
    hostValue: string;
    uiSize: string;
    tindex: string;
}

export interface MoneyTransferAdditionalServicesTxnEntryResultDto {
    id: string;
    filedLabel: string;
    hostFieldTag: string;
    dataType: string;
    requiredString: string;
    dataLength: string;
    uiSize: string;
    newLine: string;
    mask: string;
    tindex: string;
}

export interface MoneyTransferAdditionalServicesComboListResultDto {
    id: string;
    filedLabel: string;
    hostFieldTag: string;
    requiredString: string;
    dataLength: string;
    newLine: string;
    items: MoneyTransferAdditionalServicesComboListItemResultDto[];
    tindex: string;
}

export interface MoneyTransferAdditionalServicesRadioButtonGroupResultDto {
    id: string;
    filedLabel: string;
    hostFieldTag: string;
    uiSize: string;
    requiredString: string;
    radioButtons: MoneyTransferAdditionalServicesRadioButtonResultDto[];
    tindex: string;
}

export interface MoneyTransferAdditionalServicesCheckBoxResultDto {
    id: string;
    hostFieldTag: string;
    filedLabel: string;
    tindex: string;
}

export interface MoneyTransferAdditionalSubServiceOutputFieldResultDto {
    id: string;
    filedLabel: string;
    hostFieldTag: string;
    dataType: string;
    description: string;
}

export interface MoneyTransferAdditionalServicesComboListItemResultDto {
    value: string;
    fieldLabel: string;
    tindex: string;
}

export interface MoneyTransferAdditionalServicesRadioButtonResultDto {
    id: string;
    filedLabel: string;
    hostValue: string;
    uiSize: string;
    tindex: string;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /money-transfer/cancel/cancel-send
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCancelController.cancelTransaction
     */
    cancelTransaction(request: MoneyTransferCancelTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferCanceledTransactionResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/cancel/cancel-send`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/change-request/complete
     * Java method: com.europoint.moneytransfer.web.AgentChangeRequestController.complete
     */
    complete(queryParams: { changeRequestId: string; }, options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/change-request/complete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/change-request/create
     * Java method: com.europoint.moneytransfer.web.AgentChangeRequestController.createChangeRequest
     */
    createChangeRequest(createChangeRequestDto: CreateChangeRequestDto, options?: O): RestResponse<Mono<WebUUIDResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/change-request/create`, data: createChangeRequestDto, options: options });
    }

    /**
     * HTTP GET /money-transfer/change-request/get-all
     * Java method: com.europoint.moneytransfer.web.AgentChangeRequestController.getAll
     */
    getAll$GET$money_transfer_changerequest_getall(options?: O): RestResponse<Mono<WebListResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/change-request/get-all`, options: options });
    }

    /**
     * HTTP GET /money-transfer/change-request/get-by-external-reference-number/{reference_number}
     * Java method: com.europoint.moneytransfer.web.AgentChangeRequestController.getByExternalReferenceNumber
     */
    getByExternalReferenceNumber$GET$money_transfer_changerequest_getbyexternalreferencenumber_reference_number(reference_number: string, options?: O): RestResponse<Mono<WebListResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/change-request/get-by-external-reference-number/${reference_number}`, options: options });
    }

    /**
     * HTTP GET /money-transfer/change-request/get-by-internal-reference-number/{reference_number}
     * Java method: com.europoint.moneytransfer.web.AgentChangeRequestController.getByInternalReferenceNumber
     */
    getByInternalReferenceNumber$GET$money_transfer_changerequest_getbyinternalreferencenumber_reference_number(reference_number: string, options?: O): RestResponse<Mono<WebListResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/change-request/get-by-internal-reference-number/${reference_number}`, options: options });
    }

    /**
     * HTTP GET /money-transfer/change-request/get/{ID}
     * Java method: com.europoint.moneytransfer.web.AgentChangeRequestController.getById
     */
    getById$GET$money_transfer_changerequest_get_ID(ID: string, options?: O): RestResponse<Mono<WebResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/change-request/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /money-transfer/check-status
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.checkStatusTransaction
     */
    checkStatusTransaction$POST$money_transfer_checkstatus(request: MoneyTransferCheckPayStatusDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPayStatusCheckResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/check-status`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/connection-configuration/create
     * Java method: com.europoint.moneytransfer.web.ConnectionConfigurationController.createConnectionConfiguration
     */
    createConnectionConfiguration(createConnectionConfigurationDto: CreateConnectionConfigurationDto, options?: O): RestResponse<Mono<WebUUIDResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/connection-configuration/create`, data: createConnectionConfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/connection-configuration/get-all
     * Java method: com.europoint.moneytransfer.web.ConnectionConfigurationController.getAll
     */
    getAll$POST$money_transfer_connectionconfiguration_getall(options?: O): RestResponse<Mono<WebListResponseEntity<ConnectionConfigurationCommon>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/connection-configuration/get-all`, options: options });
    }

    /**
     * HTTP POST /money-transfer/core/get-all-paid-out
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.getAllPaidOutRequests
     */
    getAllPaidOutRequests$POST$money_transfer_core_getallpaidout(queryParams?: { is_digital?: boolean; }, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferPayOutMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/core/get-all-paid-out`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/core/get-all-sent
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.getAllSentRequests
     */
    getAllSentRequests$POST$money_transfer_core_getallsent(queryParams?: { is_digital?: boolean; }, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/core/get-all-sent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/core/get-by-external-reference-number
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.getByExternalReferenceNumber
     */
    getByExternalReferenceNumber$GET$money_transfer_core_getbyexternalreferencenumber(queryParams: { "external-reference-number": string; is_digital?: boolean; }, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/core/get-by-external-reference-number`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/core/get-by-id
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.getById
     */
    getById$GET$money_transfer_core_getbyid(queryParams: { id: string; is_digital?: boolean; }, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/core/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/core/get-by-internal-reference-number
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.getByInternalReferenceNumber
     */
    getByInternalReferenceNumber$GET$money_transfer_core_getbyinternalreferencenumber(queryParams: { "internal-reference-number": string; is_digital?: boolean; }, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/core/get-by-internal-reference-number`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/core/get-suspend-notifications
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.getSuspendNotifications
     */
    getSuspendNotifications$GET$money_transfer_core_getsuspendnotifications(queryParams?: { is_digital?: boolean; }, options?: O): RestResponse<Mono<WebListResponseEntity<SuspendRequestNotificationDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/core/get-suspend-notifications`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/core/mark-read-suspend-notifications
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.markAsReadSuspendNotifications
     */
    markAsReadSuspendNotifications$POST$money_transfer_core_markreadsuspendnotifications(queryParams: { notification_id: string; is_digital?: boolean; }, options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/core/mark-read-suspend-notifications`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/core/search-internal-by-external-reference-number
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.searchInternalByExternalReferenceNumber
     */
    searchInternalByExternalReferenceNumber$GET$money_transfer_core_searchinternalbyexternalreferencenumber(queryParams: { reference_number: string; is_digital?: boolean; }, options?: O): RestResponse<Mono<WebResponseEntity<InternalTransactionDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/core/search-internal-by-external-reference-number`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/core/search-sent-for-user
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferCoreController.searchSentForUser
     */
    searchSentForUser$POST$money_transfer_core_searchsentforuser(request: MoneyTransferSearchRequest, options?: O): RestResponse<Mono<WebPageResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/core/search-sent-for-user`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-additional-services
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getAdditionalServices
     */
    getAdditionalServices$POST$money_transfer_dasinquiry_getadditionalservices(request: MoneyTransferGetAdditionalServicesRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferGetAdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-additional-services`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-all-countries
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getCountries
     */
    getCountries$POST$money_transfer_dasinquiry_getallcountries(request: MoneyTransferGetCountriesRequest, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferCountryResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-all-countries`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-all-destination-countries
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getDestinationCountries
     */
    getDestinationCountries$POST$money_transfer_dasinquiry_getalldestinationcountries(request: MoneyTransferGetDestinationCountriesRequest, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferDestinationCountryResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-all-destination-countries`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-cities
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getCities
     */
    getCities$POST$money_transfer_dasinquiry_getcities(request: MoneyTransferGetCitiesRequest, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferCityResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-cities`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-delivery-services
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getDeliveryServices
     */
    getDeliveryServices$POST$money_transfer_dasinquiry_getdeliveryservices(request: MoneyTransferGetDeliveryServicesRequest, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferDeliveryServiceDataCommon>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-delivery-services`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-id-documents
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getIdDocuments
     */
    getIdDocuments$POST$money_transfer_dasinquiry_getiddocuments(request: MoneyTransferGetIdDocumentsRequest, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferIdDocumentResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-id-documents`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/das-inquiry/get-states
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDasInquiryController.getStates
     */
    getStates$POST$money_transfer_dasinquiry_getstates(request: MoneyTransferGetStatesRequest, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferStateResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/das-inquiry/get-states`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-additional-services
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getAdditionalServices
     */
    getAdditionalServices$POST$money_transfer_digital_getadditionalservices(request: MoneyTransferGetAdditionalServicesReqDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferGetAdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-additional-services`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-all-countries
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getCountries
     */
    getCountries$POST$money_transfer_digital_getallcountries(request: MoneyTransferGetCountriesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferCountryResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-all-countries`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-all-destination-countries
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getDestinationCountries
     */
    getDestinationCountries$POST$money_transfer_digital_getalldestinationcountries(request: MoneyTransferGetDestinationCountriesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferDestinationCountryResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-all-destination-countries`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/digital/get-by-external-reference-number/{external-reference-number}
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getByExternalReferenceNumber
     */
    getByExternalReferenceNumber$GET$money_transfer_digital_getbyexternalreferencenumber_externalReferenceNumber(externalReferenceNumber: string, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/digital/get-by-external-reference-number/${externalReferenceNumber}`, options: options });
    }

    /**
     * HTTP GET /money-transfer/digital/get-by-id/{id}
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getById
     */
    getById$GET$money_transfer_digital_getbyid_id(id: string, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/digital/get-by-id/${id}`, options: options });
    }

    /**
     * HTTP GET /money-transfer/digital/get-by-internal-reference-number/{internal-reference-number}
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getByInternalReferenceNumber
     */
    getByInternalReferenceNumber$GET$money_transfer_digital_getbyinternalreferencenumber_internalReferenceNumber(internalReferenceNumber: string, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/digital/get-by-internal-reference-number/${internalReferenceNumber}`, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-cities
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getCities
     */
    getCities$POST$money_transfer_digital_getcities(request: MoneyTransferGetCitiesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferCityResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-cities`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-delivery-services
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getDeliveryServices
     */
    getDeliveryServices$POST$money_transfer_digital_getdeliveryservices(request: MoneyTransferGetDeliveryServicesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferDeliveryServiceDataCommon>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-delivery-services`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-id-documents
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getIdDocuments
     */
    getIdDocuments$POST$money_transfer_digital_getiddocuments(request: MoneyTransferGetIdDocumentsDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferIdDocumentResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-id-documents`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/get-states
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getStates
     */
    getStates$POST$money_transfer_digital_getstates(request: MoneyTransferGetStatesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferStateResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/get-states`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/digital/get-suspend-notifications
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.getSuspendNotifications
     */
    getSuspendNotifications$GET$money_transfer_digital_getsuspendnotifications(options?: O): RestResponse<Mono<WebListResponseEntity<SuspendRequestNotificationDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/digital/get-suspend-notifications`, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/mark-read-suspend-notifications
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.markAsReadSuspendNotifications
     */
    markAsReadSuspendNotifications$POST$money_transfer_digital_markreadsuspendnotifications(queryParams: { notification_id: string; }, options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/mark-read-suspend-notifications`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/price
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.priceTransaction
     */
    priceTransaction$POST$money_transfer_digital_price(request: MoneyTransferPriceTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPricingResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/price`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/search-sent-for-user
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.searchSentForUser
     */
    searchSentForUser$POST$money_transfer_digital_searchsentforuser(request: SearchRequest, options?: O): RestResponse<Mono<WebPageResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/search-sent-for-user`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/send
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.sendTransaction
     */
    sendTransaction$POST$money_transfer_digital_send(request: MoneyTransferDigitalSendTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionDigitalSendingResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/send`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/digital/validate
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferDigitalController.validateTransaction
     */
    validateTransaction$POST$money_transfer_digital_validate(request: MoneyTransferDigitalValidateTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/digital/validate`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/create-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.createFormConfiguration
     */
    createFormConfiguration(createFormConfigurationBaseDto: CreateFormConfigurationBaseDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/create-form-configuration`, data: createFormConfigurationBaseDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/delete-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.deleteFormConfiguration
     */
    deleteFormConfiguration(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/delete-form-configuration`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-all-wu-money-sending-sender-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getAllWuMoneySendingSenderFormConfiguration
     */
    getAllWuMoneySendingSenderFormConfiguration(options?: O): RestResponse<WebListResponseEntity<WUMoneySendingSenderFormConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-all-wu-money-sending-sender-form-configuration`, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getFormConfiguration
     */
    getFormConfiguration(queryParams: { configurationType: ConfigurationType; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-form-configuration`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-wu-money-receiving-user-search-by-country-id
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getWuMoneyReceivingUserSearchByCountryId
     */
    getWuMoneyReceivingUserSearchByCountryId(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-wu-money-receiving-user-search-by-country-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-wu-money-sending-receiver-by-destination-country-id
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getWuMoneySendingReceiverByDestinationCountryId
     */
    getWuMoneySendingReceiverByDestinationCountryId(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-wu-money-sending-receiver-by-destination-country-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-wu-money-sending-sender-form-configuration-by-amount
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getWuMoneySendingSenderFormConfigurationByAmount
     */
    getWuMoneySendingSenderFormConfigurationByAmount(queryParams?: { amount?: number; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-wu-money-sending-sender-form-configuration-by-amount`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-wu-money-sending-sender-form-configuration-by-amounts
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getWuMoneySendingSenderFormConfigurationByAmounts
     */
    getWuMoneySendingSenderFormConfigurationByAmounts(queryParams?: { amountFrom?: number; amountTo?: number; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-wu-money-sending-sender-form-configuration-by-amounts`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-wu-money-sending-transaction-form-configuration-by-amount
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getWuMoneySendingTransactionFormConfigurationByAmount
     */
    getWuMoneySendingTransactionFormConfigurationByAmount(queryParams: { amount: number; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-wu-money-sending-transaction-form-configuration-by-amount`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/form-configuration/get-wu-money-sending-transaction-form-configuration-by-amounts
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.getWuMoneySendingTransactionFormConfigurationByAmounts
     */
    getWuMoneySendingTransactionFormConfigurationByAmounts(queryParams: { amountFrom: number; amountTo?: number; }, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/form-configuration/get-wu-money-sending-transaction-form-configuration-by-amounts`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/set-common-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.setCommonFormConfiguration
     */
    setCommonFormConfiguration(setCommonFormConfigurationDto: CreateFormConfigurationBaseDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/set-common-form-configuration`, data: setCommonFormConfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/set-wu-money-receiving-user-search-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.setWuMoneyReceivingUserSearchFormConfiguration
     */
    setWuMoneyReceivingUserSearchFormConfiguration(setWuMoneyReceivingUserSearchFormConfigurationDto: CreateFormConfigurationBaseDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/set-wu-money-receiving-user-search-form-configuration`, data: setWuMoneyReceivingUserSearchFormConfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/set-wu-money-sending-receiver-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.setWuMoneySendingReceiverFormCongfiguration
     */
    setWuMoneySendingReceiverFormCongfiguration(setWuMoneySendingReciverFormConfigurationDto: CreateFormConfigurationBaseDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/set-wu-money-sending-receiver-form-configuration`, data: setWuMoneySendingReciverFormConfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/set-wu-money-sending-sender-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.setWuMoneySendingSenderFormCongfiguration
     */
    setWuMoneySendingSenderFormCongfiguration(setWuMoneySendingSenderFormCongfigurationDto: CreateFormConfigurationBaseDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/set-wu-money-sending-sender-form-configuration`, data: setWuMoneySendingSenderFormCongfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/set-wu-money-sending-transaction-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.setWuMoneySendingTransactionFormCongfiguration
     */
    setWuMoneySendingTransactionFormCongfiguration(setWuMoneySendingReciverFormConfigurationDto: CreateFormConfigurationBaseDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/set-wu-money-sending-transaction-form-configuration`, data: setWuMoneySendingReciverFormConfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/update-default-form-configuration-by-type
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.updateDefaultFormConfigurationByType
     */
    updateDefaultFormConfigurationByType(updateDefaultFormConfigurationByTypeDto: UpdateDefaultFormConfigurationByTypeDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/update-default-form-configuration-by-type`, data: updateDefaultFormConfigurationByTypeDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/form-configuration/update-form-configuration
     * Java method: com.europoint.moneytransfer.web.FormConfigurationController.updateFormConfiguration
     */
    updateFormConfiguration(updateFormConfigurationDto: UpdateFormConfigurationDto, options?: O): RestResponse<WebResponseEntity<FormConfigurationBaseResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/form-configuration/update-form-configuration`, data: updateFormConfigurationDto, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-additional-services
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getAdditionalServices
     */
    getAdditionalServices$POST$money_transfer_getadditionalservices(request: MoneyTransferGetAdditionalServicesReqDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferGetAdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-additional-services`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-all-countries
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getCountries
     */
    getCountries$POST$money_transfer_getallcountries(request: MoneyTransferGetCountriesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferCountryResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-all-countries`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-all-destination-countries
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getDestinationCountries
     */
    getDestinationCountries$POST$money_transfer_getalldestinationcountries(request: MoneyTransferGetDestinationCountriesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferDestinationCountryResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-all-destination-countries`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-all-paid-out
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getAllPaidOutRequests
     */
    getAllPaidOutRequests$POST$money_transfer_getallpaidout(options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferPayOutMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-all-paid-out`, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-all-sent
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getAllSentRequests
     */
    getAllSentRequests$POST$money_transfer_getallsent(options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-all-sent`, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-cities
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getCities
     */
    getCities$POST$money_transfer_getcities(request: MoneyTransferGetCitiesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferCityResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-cities`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-id-documents
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getIdDocuments
     */
    getIdDocuments$POST$money_transfer_getiddocuments(request: MoneyTransferGetIdDocumentsDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferIdDocumentResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-id-documents`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/get-states
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.getStates
     */
    getStates$POST$money_transfer_getstates(request: MoneyTransferGetStatesDto, options?: O): RestResponse<Mono<WebListResponseEntity<MoneyTransferStateResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/get-states`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/inquiry/search
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferSearchController.searchForTransaction
     */
    searchForTransaction$POST$money_transfer_inquiry_search(request: MoneyTransferSearchForTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSearchResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/inquiry/search`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/inquiry/search-by-internal-reference-number
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferSearchController.searchForTransactionByInternalReferenceNumber
     */
    searchForTransactionByInternalReferenceNumber$POST$money_transfer_inquiry_searchbyinternalreferencenumber(request: MoneyTransferSearchForTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSearchResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/inquiry/search-by-internal-reference-number`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/inquiry/search-with-retry
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferSearchController.searchForTransactionWithRetry
     */
    searchForTransactionWithRetry$POST$money_transfer_inquiry_searchwithretry(request: MoneyTransferSearchForTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSearchResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/inquiry/search-with-retry`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/master-agent-change-request/approve
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.approve
     */
    approve(queryParams: { changeRequestId: string; }, options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/master-agent-change-request/approve`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/master-agent-change-request/deny
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.deny
     */
    deny(queryParams: { changeRequestId: string; }, options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/master-agent-change-request/deny`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/master-agent-change-request/get-all
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.getAll
     */
    getAll$GET$money_transfer_masteragentchangerequest_getall(options?: O): RestResponse<Mono<WebListResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/master-agent-change-request/get-all`, options: options });
    }

    /**
     * HTTP GET /money-transfer/master-agent-change-request/get-by-external-reference-number/{reference_number}
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.getByExternalReferenceNumber
     */
    getByExternalReferenceNumber$GET$money_transfer_masteragentchangerequest_getbyexternalreferencenumber_reference_number(reference_number: string, options?: O): RestResponse<Mono<WebListResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/master-agent-change-request/get-by-external-reference-number/${reference_number}`, options: options });
    }

    /**
     * HTTP GET /money-transfer/master-agent-change-request/get-by-internal-reference-number/{reference_number}
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.getByInternalReferenceNumber
     */
    getByInternalReferenceNumber$GET$money_transfer_masteragentchangerequest_getbyinternalreferencenumber_reference_number(reference_number: string, options?: O): RestResponse<Mono<WebListResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/master-agent-change-request/get-by-internal-reference-number/${reference_number}`, options: options });
    }

    /**
     * HTTP GET /money-transfer/master-agent-change-request/get/{ID}
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.getById
     */
    getById$GET$money_transfer_masteragentchangerequest_get_ID(ID: string, options?: O): RestResponse<Mono<WebResponseEntity<ChangeRequestCommon>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/master-agent-change-request/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /money-transfer/master-agent-change-request/start-processing
     * Java method: com.europoint.moneytransfer.web.MasterAgentChangeRequestController.startProcessing
     */
    startProcessing(queryParams: { changeRequestId: string; }, options?: O): RestResponse<Mono<WebBooleanResponse>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/master-agent-change-request/start-processing`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/master-data/countries-by-name
     * Java method: com.europoint.moneytransfer.web.MasterDataController.getCountriesByName
     */
    getCountriesByName(queryParams: { query: string; }, options?: O): RestResponse<WebListResponseEntity<Country>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/master-data/countries-by-name`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /money-transfer/pay-out
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.payOutTransaction
     */
    payOutTransaction$POST$money_transfer_payout(request: MoneyTransferPayOutTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPayOutResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/pay-out`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/price
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.priceTransaction
     */
    priceTransaction$POST$money_transfer_price(request: MoneyTransferPriceTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPricingResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/price`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/receive/check-status
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferReceiveController.checkStatusTransaction
     */
    checkStatusTransaction$POST$money_transfer_receive_checkstatus(request: MoneyTransferCheckPayStatusRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPayStatusCheckResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/receive/check-status`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/receive/pay-out
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferReceiveController.payOutTransaction
     */
    payOutTransaction$POST$money_transfer_receive_payout(request: MoneyTransferPayOutTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPayOutResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/receive/pay-out`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/search
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.searchForTransaction
     */
    searchForTransaction$POST$money_transfer_search(request: MoneyTransferSearchForTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSearchResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/search`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/search-by-internal-reference-number
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.searchForTransactionByInternalReferenceNumber
     */
    searchForTransactionByInternalReferenceNumber$POST$money_transfer_searchbyinternalreferencenumber(request: MoneyTransferSearchForTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSearchResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/search-by-internal-reference-number`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/search-internal-by-external-reference-number/{reference_number}
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.searchInternalByExternalReferenceNumber
     */
    searchInternalByExternalReferenceNumber$GET$money_transfer_searchinternalbyexternalreferencenumber_reference_number(reference_number: string, options?: O): RestResponse<Mono<WebResponseEntity<InternalTransactionDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/search-internal-by-external-reference-number/${reference_number}`, options: options });
    }

    /**
     * HTTP POST /money-transfer/search-with-retry
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.searchForTransactionWithRetry
     */
    searchForTransactionWithRetry$POST$money_transfer_searchwithretry(request: MoneyTransferSearchForTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSearchResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/search-with-retry`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/send
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.sendTransaction
     */
    sendTransaction$POST$money_transfer_send(request: MoneyTransferSendTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSendingResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/send`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/send/price
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferSendController.priceTransaction
     */
    priceTransaction$POST$money_transfer_send_price(request: MoneyTransferPriceTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionPricingResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/send/price`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/send/send-money
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferSendController.sendTransaction
     */
    sendTransaction$POST$money_transfer_send_sendmoney(request: MoneyTransferSendTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferTransactionSendingResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/send/send-money`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/send/validate
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferSendController.validateTransaction
     */
    validateTransaction$POST$money_transfer_send_validate(request: MoneyTransferValidateSendTransactionRequest, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/send/validate`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/validate
     * Java method: com.europoint.moneytransfer.web.money.MoneyTransferController.validateTransaction
     */
    validateTransaction$POST$money_transfer_validate(request: MoneyTransferValidateSendTransactionDto, options?: O): RestResponse<Mono<WebResponseEntity<MoneyTransferSendMoneyRequestResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/validate`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.get
     */
    get(request: GetAdditionalServicesReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-all
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getAll
     */
    getAll$GET$moneytransfer_additionalservices_getall(queryParams: { serviceProviderCode: string; }, options?: O): RestResponse<Mono<WebListResponseEntity<AdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-check-box-record
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getCheckBoxFieldRecord
     */
    getCheckBoxFieldRecord(request: GetAdditionalServicesFieldRecordReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesCheckBoxDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-check-box-record`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-combo-list-record
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getComboRecord
     */
    getComboRecord(request: GetAdditionalServicesFieldRecordReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesComboListDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-combo-list-record`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-internal
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getInternal
     */
    getInternal(request: GetAdditionalServicesReqDto, options?: O): RestResponse<Mono<WebResponseEntity<InternalAdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-internal`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-ouptut-field-record
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getOutputFieldRecord
     */
    getOutputFieldRecord(request: GetAdditionalServicesFieldRecordReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesOutputFieldDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-ouptut-field-record`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-radio-button-group-record
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getRadioButtonGroupRecord
     */
    getRadioButtonGroupRecord(request: GetAdditionalServicesFieldRecordReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesRadioButtonGroupDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-radio-button-group-record`, data: request, options: options });
    }

    /**
     * HTTP GET /money-transfer/additional-services/get-text-entry-record
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.getTxtEntryRecord
     */
    getTxtEntryRecord(request: GetAdditionalServicesFieldRecordReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesTxnEntryDto>>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`money-transfer/additional-services/get-text-entry-record`, data: request, options: options });
    }

    /**
     * HTTP POST /money-transfer/additional-services/save
     * Java method: com.europoint.moneytransfer.web.AdditionalServicesController.save
     */
    save(request: SaveAdditionalServicesReqDto, options?: O): RestResponse<Mono<WebResponseEntity<AdditionalServicesResultDto>>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`money-transfer/additional-services/save`, data: request, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

export const enum ConfigurationType {
    WU_MONEY_RECEIVING_TRANSACTION_SEARCH = "WU_MONEY_RECEIVING_TRANSACTION_SEARCH",
    WU_MONEY_RECEIVING_TRANSACTION = "WU_MONEY_RECEIVING_TRANSACTION",
    WU_MONEY_RECEIVING_USER_SEARCH = "WU_MONEY_RECEIVING_USER_SEARCH",
    WU_MONEY_RECEIVING_USER_SENDER = "WU_MONEY_RECEIVING_USER_SENDER",
    WU_MONEY_RECEIVING_CONFIRM_DATA = "WU_MONEY_RECEIVING_CONFIRM_DATA",
    WU_MONEY_SENDING_RECEIVER = "WU_MONEY_SENDING_RECEIVER",
    WU_MONEY_SENDING_SENDER = "WU_MONEY_SENDING_SENDER",
    WU_MONEY_SENDING_TRANSACTION = "WU_MONEY_SENDING_TRANSACTION",
    WU_MONEY_SENDING_CALCULATION = "WU_MONEY_SENDING_CALCULATION",
    WU_MONEY_SENDING_CALCULATOR = "WU_MONEY_SENDING_CALCULATOR",
    WU_MONEY_SENDING_FINAL_CALCULATION = "WU_MONEY_SENDING_FINAL_CALCULATION",
    WU_MONEY_SENDING_MAIN_INFO = "WU_MONEY_SENDING_MAIN_INFO",
    WU_MONEY_RECEIVING_USER_RECEIVER = "WU_MONEY_RECEIVING_USER_RECEIVER",
    ADDITIONAL_DATA = "ADDITIONAL_DATA",
    PAYMENT_ORDER = "PAYMENT_ORDER",
}

export const enum ChangeRequestType {
    RECEIVER_DETAILS = "RECEIVER_DETAILS",
    SENDER_DETAILS = "SENDER_DETAILS",
    DESTINATION = "DESTINATION",
    CANCEL_REFUND = "CANCEL_REFUND",
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum TransactionType {
    SEND = "SEND",
    RECEIVE = "RECEIVE",
}

export const enum ChangeRequestStateType {
    CREATED = "CREATED",
    PROCESSING = "PROCESSING",
    APPROVED = "APPROVED",
    DENIED = "DENIED",
    COMPLETED = "COMPLETED",
}

export const enum RequestUserType {
    Undefined = "Undefined",
    ProviderUser = "ProviderUser",
    MasterAgentUser = "MasterAgentUser",
    MasterAgentService = "MasterAgentService",
    WebMasterAgentUser = "WebMasterAgentUser",
    AgentUser = "AgentUser",
    AgentService = "AgentService",
    WebAgentUser = "WebAgentUser",
    MerchantUser = "MerchantUser",
    MerchantService = "MerchantService",
    WebMerchantUser = "WebMerchantUser",
    Developer = "Developer",
    AllUsers = "AllUsers",
    AllServices = "AllServices",
    AllMasterAgent = "AllMasterAgent",
    AllAgent = "AllAgent",
    AllMerchant = "AllMerchant",
    AllMasterAgentAdmin = "AllMasterAgentAdmin",
    AllPlatformAdmin = "AllPlatformAdmin",
    TestDevelopment = "TestDevelopment",
    DataService = "DataService",
}

export const enum SessionRoleType {
    Primary = "Primary",
    Secondary = "Secondary",
    Registration = "Registration",
}

export const enum SuspendStatus {
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
}

export const enum Operator {
    EQUAL = "EQUAL",
    NOT_EQUAL = "NOT_EQUAL",
    LIKE = "LIKE",
    NOT_LIKE = "NOT_LIKE",
    STARTS_WITH = "STARTS_WITH",
    END_WITH = "END_WITH",
    IN = "IN",
    NOT_IN = "NOT_IN",
    GREATER_THAN = "GREATER_THAN",
    GREATER_OR_EQUAL_TO = "GREATER_OR_EQUAL_TO",
    LESS_THAN = "LESS_THAN",
    LESS_OR_EQUAL_TO = "LESS_OR_EQUAL_TO",
    BETWEEN = "BETWEEN",
}

export const enum FieldType {
    BOOLEAN = "BOOLEAN",
    CHAR = "CHAR",
    DATE = "DATE",
    INSTANT = "INSTANT",
    DOUBLE = "DOUBLE",
    INTEGER = "INTEGER",
    LONG = "LONG",
    STRING = "STRING",
    UUID = "UUID",
    ENUM_STRING = "ENUM_STRING",
}

export const enum SortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
